/** Keep in sync with backend App\Support\AllowedAttachmentTypes */
export const ORDER_ATTACHMENT_EXTENSIONS = [
  'stl', 'ply', 'obj',
  'zip', 'pdf',
  'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'heic', 'heif', 'tiff', 'tif',
  'mp4', 'm4v', 'mov', 'avi', 'wmv', 'webm', 'mkv', 'mpeg', 'mpg', '3gp', 'flv',
  'doc', 'docx', 'xls', 'xlsx',
];

export const ORDER_ATTACHMENT_MAX_BYTES = 20 * 1024 * 1024;

export const ORDER_ATTACHMENT_ACCEPT =
  '.stl,.ply,.obj,.zip,.pdf,.jpg,.jpeg,.png,.gif,.bmp,.webp,.svg,.heic,.heif,.tiff,.tif,.mp4,.m4v,.mov,.avi,.wmv,.webm,.mkv,.mpeg,.mpg,.3gp,.flv,.doc,.docx,.xls,.xlsx,image/*,video/*';
